import { ERROR_API_CALL_FAILED } from '../../../common/framework/constants';
import { apiGet } from '../../framework/client';

import { Customer } from '../../../common/application/model/Customer';
import { Option } from '../service/application_options_service';

export async function getCustomerGroupCustomers(customerId: string): Promise<Option[]> {
    const response = await apiGet(`/api/customer/${customerId}/group-customers`);
    if (response.status === 200) {
        const data = (await response.json()) as Customer[];
        return data.map((o) => {
            return { id: o.id, label: o.name };
        });
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}
